import { createContext } from 'react'

/**
 * Team application context interface
 */
export interface TeamApplication {
  refresh: () => void
}

/**
 * Application context for team pages
 */
export const TeamAppContext = createContext<TeamApplication>(null as any)
